export default "__VITE_ASSET__D4KzUvN1__"